import { queryDefinitionsNavigation } from '../index.js';
import type { CodeNavOpContext } from './code-nav-op-context.js';
import type { CodeNavHttpBody } from './types.js';

export async function runDefinitionsOp(ctx: CodeNavOpContext): Promise<CodeNavHttpBody> {
  const { definitions, confidentTarget } = await queryDefinitionsNavigation(
    ctx.sessionParentPath,
    ctx.reqPath,
    ctx.line,
    ctx.column,
  );
  return { indexReady: true, definitions, confidentTarget };
}
